const icons = require('./icons.json');
const info = require('./info.json');
const metadata = require('./metadata.json');
const chars = {};

exports.icons = icons;
exports.info = info;
exports.metadata = metadata;
exports.chars = chars;
